import { useCallback } from "react";

import { useSearchParams } from "next/navigation";
import { useRouter } from "next/router";

import { trpc } from "../helpers/trpc";

export const useCanny = () => {
  const { mutateAsync: execGetCannyToken } = trpc.getCannyToken.useMutation();
  const router = useRouter();
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());
  const { redirect: cannyRedirection, companyID } = query as {
    redirect: string | null;
    companyID: string | null;
  };
  const redirectToCanny = useCallback(async () => {
    const response = await execGetCannyToken();
    const cannyUrl = `https://canny.io/api/redirects/sso?companyID=${companyID}&ssoToken=${
      response?.object || ""
    }&redirect=${cannyRedirection}`;

    return router.push(cannyUrl);
  }, [cannyRedirection, companyID, execGetCannyToken, router]);

  return { redirectToCanny };
};
